import * as React from "react";
import {ErrorInfo} from "react";


interface State {
    error: Error | null;
    errorInfo: ErrorInfo | null;
}

class ErrorBoundary extends React.Component<React.PropsWithChildren, State> {
    readonly state: State = {
        error: null,
        errorInfo: null,
    };

    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        this.setState({
            error: error,
            errorInfo: errorInfo
        })
    }

    render() {
        const {children} = this.props;
        const {errorInfo, error} = this.state;
        return errorInfo ? (
            <div>
                <h2>Something went wrong.</h2>
                <details style={{whiteSpace: 'pre-wrap'}}>
                    {error && error.toString()}
                </details>
            </div>
        ) : children
    }
}

export default ErrorBoundary;